/* CLOWN · Pages Ressources / Contact / Aide / Légal / Recherche / 404.
   Une seule initialisation par élément ; compatible avec les rechargements de l'éditeur Shopify. */
(() => {
  if (window.ClownSupportPages) return;
  const fold = (value) => (value || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().trim();

  /* ---------- Filtres Ressources ---------- */
  const initFilters = (root) => {
    if (root.dataset.crsReady) return;
    root.dataset.crsReady = 'true';
    const buttons = [...root.querySelectorAll('[data-crs-filter]')];
    const items = [...root.querySelectorAll('[data-crs-item]')];
    const scopes = [...root.querySelectorAll('[data-crs-filter-scope]')];
    const empty = root.querySelector('[data-crs-filter-empty]');
    const status = root.querySelector('[data-crs-filter-status]');
    const apply = (key) => {
      let shown = 0;
      items.forEach((item) => {
        const cats = (item.dataset.crsCat || '').split(/\s+/);
        const filteredOnly = item.closest('[data-crs-filtered-only]');
        const visible = (key === 'all' && !filteredOnly) || (key !== 'all' && cats.includes(key));
        item.hidden = !visible;
        if (visible) { shown += 1; item.classList.add('is-in'); }
      });
      scopes.forEach((scope) => { scope.hidden = !scope.querySelector('[data-crs-item]:not([hidden])'); });
      buttons.forEach((button) => { if (button.closest('.crs-tabs')) button.setAttribute('aria-pressed', String(button.dataset.crsFilter === key)); });
      if (empty) empty.hidden = shown > 0;
      if (status) status.textContent = key === 'all' ? window.clownI18n.message_25 : window.clownI18n.resources_shown.replace('[count]', shown);
    };
    buttons.forEach((button) => button.addEventListener('click', () => apply(button.dataset.crsFilter)));
    // Keep the Figma selection as the landing view; blog pagination opens its article category.
    apply(location.hash === '#les-articles' || new URLSearchParams(location.search).has('page') ? 'atelier' : 'all');
  };

  /* ---------- Recherche dans l'aide ---------- */
  const initHelpSearch = (form) => {
    if (form.dataset.crsReady) return;
    form.dataset.crsReady = 'true';
    const input = form.querySelector('input[type="search"]');
    const target = document.getElementById(form.dataset.crsHelpSearch);
    if (!input || !target) return;
    const rows = [...target.querySelectorAll('[data-crs-help-item]')];
    const status = target.querySelector('[data-crs-help-status]');
    const run = () => {
      const query = fold(input.value);
      let count = 0;
      rows.forEach((row) => {
        const match = !query || fold(row.textContent).includes(query);
        row.hidden = !match;
        if (match) count += 1;
      });
      if (query && count) { const first = rows.find((row) => !row.hidden); if (first && !rows.some((row) => !row.hidden && row.open)) first.open = true; }
      if (status) {
        status.hidden = count > 0;
        status.textContent = count ? '' : window.clownI18n.message_26;
      }
    };
    input.addEventListener('input', run);
    form.addEventListener('submit', (event) => {
      event.preventDefault();
      run();
      target.closest('section')?.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
    });
  };

  /* ---------- Mise en forme des textes légaux (présentation seulement, texte inchangé) ---------- */
  const ACRONYMS = ['UE', 'CGV', 'CGU', 'RGPD', 'CNIL', 'SAS', 'TVA', 'DOM-TOM', 'CB', 'PCI-DSS', 'GBA', 'INPI', 'ODR', 'CM2C', 'LCEN', 'SAV', 'FAQ', 'RCS', 'SIRET', 'NAF', 'CLOWN.ART', 'CLOWN'];
  const PROPER = ['Géant des Beaux-Arts', 'Cultura', 'Coliback', 'Shopify', 'Baggy', 'Paris', 'France', 'Kairos Logistique', 'Kairos', 'Discord', 'Google', 'Meta', 'Infomaniak', 'Clown.school', 'Europe', 'Union européenne'];
  const esc = (text) => text.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const isUpper = (text) => /[A-ZÀ-Ý]/.test(text) && text === text.toUpperCase();
  const sentence = (text) => {
    let out = text.toLowerCase();
    out = out.charAt(0).toUpperCase() + out.slice(1);
    ACRONYMS.forEach((word) => { out = out.replace(new RegExp(`(^|[^\\p{L}.-])${esc(word.toLowerCase())}(?=$|[^\\p{L}-])`, 'giu'), (m, pre) => pre + word); });
    PROPER.forEach((word) => { out = out.replace(new RegExp(esc(word), 'giu'), word); });
    out = out.replace(/www\.clown\.art/gi, 'www.clown.art');
    return out;
  };
  const clean = (body) => {
    body.querySelectorAll('[style]').forEach((el) => el.removeAttribute('style'));
    body.querySelectorAll('[class^="Mso"],[class*=" Mso"],font').forEach((el) => el.removeAttribute('class'));
    body.querySelectorAll('h1,h2,h3,h4,p,div').forEach((el) => {
      if (!el.textContent.replace(/ /g, ' ').trim() && !el.querySelector('img,iframe,video,table')) el.remove();
    });
    body.querySelectorAll('div').forEach((div) => { if (!div.attributes.length && div.parentNode) div.replaceWith(...div.childNodes); });
  };
  const formatLegal = (body) => {
    if (body.dataset.crsReady) return;
    body.dataset.crsReady = 'true';
    clean(body);
    const head = document.querySelector(body.dataset.crsHead || '[data-crs-legal-head]');
    // 1. Doublon du titre et date de mise à jour
    const first = body.firstElementChild;
    if (first && /^H[1-3]$/.test(first.tagName) && isUpper(first.textContent.trim())) first.remove();
    const updated = [...body.querySelectorAll('p')].slice(0, 4).find((p) => /derni[eè]re mise [àa] jour/i.test(p.textContent));
    if (updated) {
      let text = updated.textContent.replace(/\s+/g, ' ').trim();
      let next = updated.nextElementSibling;
      if (/jour\s*:?\s*$/i.test(text) && next && next.tagName === 'P' && next.textContent.trim().length < 40) { text = `${text.replace(/\s*:?\s*$/, '')} : ${next.textContent.trim()}`; next.remove(); }
      const slot = head && head.querySelector('[data-crs-legal-updated]');
      if (slot) { slot.textContent = text.replace(/\s*:\s*/, ' : '); slot.hidden = false; updated.remove(); }
    }
    // 2. Premier paragraphe = introduction
    const intro = body.firstElementChild;
    if (intro && intro.tagName === 'P') intro.classList.add('crs-legal-intro');
    // 3. Titres « ARTICLE 1. ZONES » ou « 1. Responsable » → surtitre + titre
    body.querySelectorAll('h1,h2').forEach((heading) => {
      const raw = heading.textContent.replace(/\s+/g, ' ').trim();
      let kicker = '';
      let title = raw;
      let match = raw.match(/^(ARTICLE\s+\d+[A-Z]?)\s*[.:\-–—]\s*(.+)$/i);
      if (match) { kicker = match[1].toUpperCase(); title = match[2]; }
      else if ((match = raw.match(/^(\d{1,2})\s*[.)\-–—]\s+(.+)$/))) { kicker = match[1].padStart(2, '0'); title = match[2]; }
      else if ((match = raw.match(/^(ANNEXE)\s*[—–-]\s*(.+)$/i))) { kicker = 'ANNEXE'; title = match[2]; }
      else if (/^pr[ée]ambule$/i.test(raw)) { kicker = window.clownI18n.message_29; title = window.clownI18n.message_30; }
      if (isUpper(title)) title = sentence(title);
      title = title.replace(/\s+[—–]\s+/g, ' : ');
      const h2 = document.createElement('h2');
      h2.className = 'crs-legal-h';
      if (heading.id) h2.id = heading.id;
      if (kicker) { const k = document.createElement('span'); k.className = 'crs-kicker'; k.textContent = kicker; h2.append(k); }
      const t = document.createElement('span'); t.className = 'crs-legal-h-title'; t.textContent = title; h2.append(t);
      heading.replaceWith(h2);
    });
    body.querySelectorAll('h3,h4').forEach((heading) => {
      let raw = heading.textContent.replace(/\s+/g, ' ').trim();
      if (isUpper(raw)) raw = sentence(raw);
      heading.textContent = raw.replace(/\s+[—–]\s+/g, ' : ');
    });
    // 3 bis. Encadré légal obligatoire : paragraphes suivants dans un cadre gris
    body.querySelectorAll('h3').forEach((heading) => {
      if (!/encadr[ée]/i.test(heading.textContent)) return;
      const box = document.createElement('div');
      box.className = 'crs-encadre';
      let next = heading.nextElementSibling;
      while (next && !/^H[1-4]$/.test(next.tagName)) { const n = next.nextElementSibling; box.append(next); next = n; }
      if (box.children.length) heading.after(box);
    });
    // 3 ter. Tableaux (cookies) : carte avec en-tête discret
    body.querySelectorAll('table').forEach((table) => {
      table.removeAttribute('width');
      table.querySelectorAll('[width]').forEach((c) => c.removeAttribute('width'));
      const first = table.querySelector('tr');
      if (first && [...first.cells].every((c) => c.querySelector('b,strong') || c.tagName === 'TH')) first.classList.add('crs-table-head');
      const wrap = document.createElement('div');
      wrap.className = 'crs-table';
      table.before(wrap); wrap.append(table);
      // Version mobile (maquettes 390) : une carte par ligne
      const cards = document.createElement('div');
      cards.className = 'crs-table-cards';
      [...table.rows].forEach((row) => {
        if (row.classList.contains('crs-table-head')) return;
        const cells = [...row.cells].map((c) => c.textContent.replace(/\s+/g, ' ').trim());
        if (!cells.some(Boolean)) return;
        const card = document.createElement('div'); card.className = 'crs-table-card';
        const t = document.createElement('p'); t.textContent = cells[0]; card.append(t);
        if (cells.length > 2 && cells[2]) { const d = document.createElement('p'); d.textContent = cells[2]; card.append(d); }
        const meta = cells.filter((c, i) => c && i !== 0 && i !== 2).join(' · ');
        if (meta) { const m = document.createElement('p'); m.textContent = meta; card.append(m); }
        cards.append(card);
      });
      wrap.after(cards);
    });
    // 4. Paragraphes « — texte » consécutifs → liste à puces rouges
    const dash = /^\s*[—–-]\s+/;
    [...body.children].forEach((el) => {
      if (el.tagName !== 'P' || !dash.test(el.textContent)) return;
      const prev = el.previousElementSibling;
      let list = prev && prev.matches('ul.crs-list') ? prev : null;
      if (!list) { list = document.createElement('ul'); list.className = 'crs-list'; el.before(list); }
      const li = document.createElement('li');
      li.append(...el.childNodes);
      const firstText = [...li.childNodes].find((n) => n.nodeType === 3 && n.textContent.trim());
      if (firstText) firstText.textContent = firstText.textContent.replace(dash, '');
      list.append(li);
      el.remove();
    });
    body.querySelectorAll('ul:not(.crs-list)').forEach((ul) => ul.classList.add('crs-list'));
    // 5. Fiches « Libellé : valeur » (≥ 2 lignes courtes consécutives) et blocs « <b>Nom</b> — détail »
    const labelOf = (p) => {
      const b = p.firstElementChild;
      if (!b || !/^(B|STRONG)$/.test(b.tagName) || p.firstChild !== b && p.firstChild.textContent.trim()) return null;
      return b;
    };
    const rows = [];
    [...body.children].forEach((p) => {
      if (p.tagName !== 'P') return;
      const b = labelOf(p);
      if (!b) return;
      const label = b.textContent.trim();
      const rest = p.textContent.slice(p.textContent.indexOf(b.textContent) + b.textContent.length).trim();
      if (/:\s*$/.test(label) && rest && rest.length <= 80) rows.push({ p, label: label.replace(/\s*:\s*$/, ''), values: [rest.replace(/^:\s*/, '')] });
      else if (!/:\s*$/.test(label) && label.length < 90 && (/^[—–-]\s+/.test(rest) || !rest)) {
        const values = rest ? [rest.replace(/^[—–-]\s+/, '')] : [];
        let next = p.nextElementSibling;
        const extra = [];
        const mediator = /m[ée]diat/i.test(label);
        while (next && next.tagName === 'P' && !labelOf(next) && (!next.querySelector('a') || (!mediator && next.textContent.trim() === next.querySelector('a').textContent.trim())) && next.textContent.trim().length < 260 && extra.length < 4) { extra.push(next); next = next.nextElementSibling; }
        if (!values.length && !extra.length) return;
        if (mediator) {
          const lines = extra.map((n) => n.textContent.replace(/\s+/g, ' ').trim());
          rows.push({ p, label: window.clownI18n.message_31, values: [label], extra: [], block: true, group: 'mediator' });
          lines.forEach((line, i) => {
            let m;
            if ((m = line.match(/^Inscription\s*:\s*(.+)$/i))) rows.push({ p: extra[i], label: 'Inscription', values: [m[1]], extra: [], block: true, group: 'mediator' });
            else if (/^(T[ée]l[ée]phone|T[ée]l\.?|Email)/i.test(line)) rows.push({ p: extra[i], label: 'Contact', values: [line], extra: [], block: true, group: 'mediator' });
            else rows.push({ p: extra[i], label: 'Adresse', values: [line], extra: [], block: true, group: 'mediator' });
          });
          return;
        }
        extra.forEach((n) => values.push(n.querySelector('a') ? n.cloneNode(true).childNodes : n.textContent.replace(/\s+/g, ' ').trim()));
        rows.push({ p, label, values, extra, block: true });
      }
    });
    const groups = [];
    rows.forEach((row) => {
      const last = groups[groups.length - 1];
      const prevEl = row.p.previousElementSibling;
      const lastRow = last && last[last.length - 1];
      const lastEnd = lastRow && (lastRow.extra && lastRow.extra.length ? lastRow.extra[lastRow.extra.length - 1] : lastRow.p);
      if (last && prevEl === lastEnd && !!lastRow.block === !!row.block) last.push(row); else groups.push([row]);
    });
    groups.forEach((group) => {
      if (group.length < 2 && !group[0].block) return;
      const dl = document.createElement('dl');
      dl.className = 'crs-fiche';
      group[0].p.before(dl);
      group.forEach((row) => {
        const wrap = document.createElement('div');
        wrap.className = 'crs-fiche-row';
        const dt = document.createElement('dt'); dt.textContent = row.label;
        const dd = document.createElement('dd');
        row.values.forEach((v) => { const s = document.createElement('span'); if (typeof v === 'string') s.textContent = v; else s.append(...[...v]); dd.append(s); });
        wrap.append(dt, dd); dl.append(wrap);
        row.p.remove(); (row.extra || []).forEach((n) => n.remove());
      });
    });
    // 5 bis. Annexe : formulaire type de rétractation en champs à remplir
    body.querySelectorAll('h2.crs-legal-h').forEach((h) => {
      if (!/annexe/i.test(h.textContent)) return;
      let el = h.nextElementSibling;
      let form = null;
      while (el && el.tagName !== 'H2') {
        const next = el.nextElementSibling;
        const text = el.textContent.replace(/\s+/g, ' ').trim();
        const isField = el.tagName === 'P' && (/_{3,}/.test(text) || (/:\s*$/.test(text) && form));
        if (isField) {
          if (!form) { form = document.createElement('div'); form.className = 'crs-annex-form'; el.before(form); }
          const labels = /_{3,}/.test(text) ? [...text.matchAll(/([^:_/]+?)\s*:\s*[_\s/]{3,}/g)].map((m) => m[1].trim()) : [text.replace(/\s*:\s*$/, '')];
          labels.forEach((label) => {
            const f = document.createElement('div'); f.className = 'crs-annex-field';
            const l = document.createElement('p'); l.textContent = label;
            const line = document.createElement('span'); line.setAttribute('aria-hidden', 'true');
            f.append(l, line); form.append(f);
          });
          el.remove();
        } else if (form) form = null;
        el = next;
      }
    });
    // 5 ter. Tirets cadratins en incise : « · » (présentation Figma, texte inchangé)
    const walker = document.createTreeWalker(body, NodeFilter.SHOW_TEXT);
    for (let n = walker.nextNode(); n; n = walker.nextNode()) {
      if (/[—–]/.test(n.nodeValue)) n.nodeValue = n.nodeValue.replace(/(\S)\s+[—–]\s+/g, '$1 · ');
    }
    // 6. Sommaire
    const tocs = document.querySelectorAll(`[data-crs-toc="${body.id}"]`);
    const headings = [...body.querySelectorAll('h2.crs-legal-h')];
    headings.forEach((h, i) => { if (!h.id) h.id = `${body.id}-${i + 1}`; });
    tocs.forEach((toc) => {
      const list = toc.querySelector('ol');
      if (!list) return;
      list.replaceChildren(...headings.map((h) => {
        const li = document.createElement('li');
        const a = document.createElement('a');
        a.href = `#${h.id}`;
        a.textContent = (h.querySelector('.crs-legal-h-title') || h).textContent;
        li.append(a);
        return li;
      }));
      toc.hidden = headings.length === 0;
      const count = toc.querySelector('[data-crs-toc-count]');
      if (count) count.textContent = window.clownI18n.sections_count.replace('[count]', headings.length);
    });
    if ('IntersectionObserver' in window && headings.length) {
      const links = () => document.querySelectorAll(`[data-crs-toc="${body.id}"] a`);
      const io = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          links().forEach((a) => a.classList.toggle('is-current', a.getAttribute('href') === `#${entry.target.id}`));
        });
      }, { rootMargin: '-15% 0px -70% 0px' });
      headings.forEach((h) => io.observe(h));
    }
    document.querySelectorAll(`[data-crs-toc="${body.id}"] a`).forEach((a) => a.addEventListener('click', () => { const d = a.closest('details'); if (d) d.open = false; }));
  };

  /* ---------- Formulaire de contact : états focus / erreur ---------- */
  const messages = {
    valueMissing: window.clownI18n.message_27,
    typeMismatch: window.clownI18n.message_28,
  };
  const initForm = (form) => {
    if (form.dataset.crsReady) return;
    form.dataset.crsReady = 'true';
    form.noValidate = true;
    const fields = [...form.querySelectorAll('.crs-field')];
    const check = (field, show) => {
      const input = field.querySelector('input,textarea');
      if (!input) return true;
      const error = field.querySelector('.crs-error');
      const valid = input.checkValidity();
      if (show || field.classList.contains('is-error')) {
        field.classList.toggle('is-error', !valid);
        field.classList.toggle('is-valid', valid && !!input.value.trim());
        input.setAttribute('aria-invalid', String(!valid));
        if (error) { error.textContent = valid ? '' : (input.validity.valueMissing ? messages.valueMissing : messages.typeMismatch); error.hidden = valid; }
      }
      return valid;
    };
    fields.forEach((field) => {
      const input = field.querySelector('input,textarea');
      if (!input) return;
      input.addEventListener('blur', () => { if (input.value.trim() || field.classList.contains('is-error')) check(field, true); });
      input.addEventListener('input', () => check(field, false));
    });
    form.addEventListener('submit', (event) => {
      const invalid = fields.filter((field) => !check(field, true));
      if (invalid.length) {
        event.preventDefault();
        invalid[0].querySelector('input,textarea').focus();
      }
    });
  };

  /* Placeholders raccourcis sur mobile (maquettes 390) */
  const mq = matchMedia('(max-width: 749px)');
  const initPlaceholder = (input) => {
    if (input.dataset.crsPhReady) return;
    input.dataset.crsPhReady = 'true';
    const desktop = input.placeholder;
    const swap = () => { input.placeholder = mq.matches ? input.dataset.crsPlaceholderMobile : desktop; };
    swap(); mq.addEventListener('change', swap);
  };

  const init = (scope = document) => {
    scope.querySelectorAll('.crs [data-crs-placeholder-mobile]').forEach(initPlaceholder);
    scope.querySelectorAll('[data-crs-filter-root]').forEach(initFilters);
    scope.querySelectorAll('[data-crs-help-search]').forEach(initHelpSearch);
    scope.querySelectorAll('[data-crs-legal-body]').forEach(formatLegal);
    scope.querySelectorAll('form.crs-form').forEach(initForm);
    const notice = scope.querySelector('[data-crs-notice]');
    if (notice) notice.focus({ preventScroll: false });
  };
  window.ClownSupportPages = { init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
